import React from "react";

function CompanyFormation() {
  window.scrollTo(0, 0);
  return (
    <div>
     
<section className="ftco-section" style={{padding:"0px"}}>
    <div className="container">
      <div className="row mb-5  mx-auto">
        <div className="heading-section ftco-animate fadeInUp ftco-animated">
        <h2 style={{color:"#3A3A3A"}}><b>Company Formation</b></h2>
            <div style={{color:"#5E5550"}}>
              <p>
              Nabeel Saeed Law Firm provides all related services to the lifecycle of a company from formation to day to day matters which a company requires.
              </p>
            </div>
        </div>
      </div>
    </div>
  </section>
</div>
  );
}

export default CompanyFormation;
